export const BUILD_TIME = '__TUITUI_BUILD_TIME__';
